export { type PaginationProps, default as Pagination } from './Pagination';
